import React, { Ref, useImperativeHandle, useState } from "react";
import { Box } from "@material-ui/core";
import { tesaDarkRedError } from "../../../styles/colors";

export type ErrorMessageRef = {
  show: (text: string) => void;
  hide: () => void;
};

function ErrorMessage(props: Record<string, unknown>, ref: Ref<ErrorMessageRef> | undefined) {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState<{ text: string } | undefined>(undefined);

  useImperativeHandle(ref, () => ({
    show: (text: string): void => {
      setShow(true);
      setMessage({ text });
    },
    hide: () => {
      setShow(false);
    },
  }));

  return (
    <Box style={{ display: show ? "block" : "none", color: tesaDarkRedError }} marginBottom={3}>
      {message?.text || ""}
    </Box>
  );
}

export default React.forwardRef(ErrorMessage);
